import { handleResponseLanguage } from '../../../../../../../../i18n';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';

export interface TableColumn {
  questionId: string;
  label: string;
}

const useTableColumns = (question: FlowsQuestion): TableColumn[] => {
  return (
    question.rules.table?.columns.map(({ question_id, title }) => ({
      questionId: question_id,
      label: handleResponseLanguage(title),
    })) || []
  );
};

export default useTableColumns;
